import { useEffect, useRef, useState } from "react";
import Menu from "../assets/svgs/Menu.svg";
import Edit from "../assets/svgs/Pencil.svg";
import Delete from "../assets/svgs/Recycle Bin.svg";
import { handleDropdownClose } from "../utils/utils";
import { FiRefreshCcw, FiXCircle, FiClock } from "react-icons/fi";

const ActionsMenu = ({
  handleEdit,
  handleDelete,
  showOtherOption,
  handleOtherOption,
  otherOptionTitle,
  handleExclusiveOption,
  otherWithdrawTitle,
  otherClosedTitle,
  handleWithdrawn,
  otherUnderContractTitle,
  handleUnderContract,
  handleClosed,
  otherConverttoExecutedLOI,
  handleConverttoExecutedLOI,
  otherBovTitle,
  handleConvertBov,
  handleDuplicateData,
  otherDuplicateTitle,
  felloutcontractoption,
  handlefelloutcontractOption,
  handleAssign,
  from,
}) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState(false);

  useEffect(() => {
    const handleClose = () => {
      setIsOpen(false);
      setShowMoreOptions(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  return (
    <div ref={dropdownRef} className="custom-dropdown">
      <div
        role="button"
        className="light-bg-L body-N dark-M"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <img src={Menu} alt="icon" className="sidebar-icons" />
      </div>

      {isOpen && (
        <div
          className="dropdown-list-container dropdown-end light-bg-L dark-M body-N shadow rounded-box"
          style={{ width: "180px" }}
        >
          <ul className="dropdown-list">
            

            {handleAssign && (
              <li role="button" onClick={() => { handleAssign(); setIsOpen(false); }}>
                Assign
              </li>
            )}

            <li role="button" onClick={() => { handleEdit(); setIsOpen(false); }}>
              {otherOptionTitle !== "Convert To Pipeline" && <img src={Edit} alt="icon" className="mr-3 sidebar-icons" />}
              Edit
            </li>

            {from === 'Exclusives' ? (
              <>
                <li role="button" onClick={() => { handleWithdrawn(); setIsOpen(false); }}>
                  <FiXCircle className="mr-3 text-[#585858] text-lg inline" />
                  {otherWithdrawTitle}
                </li>
                {/* <li role="button" onClick={() => { handleUnderContract(); setIsOpen(false); }}>
                   {otherUnderContractTitle}
                 </li> */}
                <li role="button" onClick={() => { handleOtherOption(); setIsOpen(false); }}>
                  <FiClock className="mr-3 text-[#585858] text-lg inline" />
                  {otherOptionTitle}
                </li>
              </>

            ) : from === 'Offers' ? (
              <>
                <li role="button" onClick={() => { handleDuplicateData(); setIsOpen(false); }}>
                  {otherDuplicateTitle}
                </li>
                <li role="button" onClick={() => { handleConverttoExecutedLOI(); setIsOpen(false); }}>
                  {otherConverttoExecutedLOI}
                </li>
              </>
            ) : from === 'ExecutedLoi' ? (
              <>
                <li role="button" onClick={() => { handleUnderContract(); setIsOpen(false); }}>
                  {otherUnderContractTitle}
                </li>

                <li role="button" onClick={() => { handlefelloutcontractOption(); setIsOpen(false); }}>
                  {felloutcontractoption}
                </li>

              </>
            ) : from === 'pipeline' ? (
              <>
                <li role="button" onClick={() => { handleConvertBov(); setIsOpen(false); }}>
                  <FiRefreshCcw className="mr-3 text-[#585858] text-lg inline" />
                  {otherBovTitle}
                </li>
              </>
            ) : from === 'lead' ? (
              <>
                <li role="button" onClick={() => { handleOtherOption(); setIsOpen(false); }}>
                  {otherOptionTitle}
                </li>
              </>
            ) : from === 'BOV' ? (
              <>
                <li role="button" onClick={() => { handleExclusiveOption(); setIsOpen(false); }}>
                  {otherOptionTitle}
                </li>
              </>
            ) : from === 'under-contract' ? (
              <>
                <li role="button" onClick={() => { handleOtherOption(); setIsOpen(false); }}>
                  {otherOptionTitle}
                </li>
                <li role="button" onClick={() => { handlefelloutcontractOption(); setIsOpen(false); }}>
                  {felloutcontractoption}
                </li>
              </>
            ) : from === 'contract-to-close' ? (
              <>
                {showOtherOption && (
                  <li role="button" onClick={() => { handleOtherOption(); setIsOpen(false); }}>
                    {otherOptionTitle}
                  </li>
                )}
              </>
            ) :
              null}


            <li
              className="red-D"
              role="button"
              onClick={() => {
                handleDelete();
                setIsOpen(false);
              }}
            >
              {otherOptionTitle !== "Convert To Pipeline" && (
                <img src={Delete} alt="icon" className="mr-3 sidebar-icons" />
              )}
              {from === "pipeline" ? (
                <>
                  Remove from <br /> Pipeline
                </>
              ) : (
                "Delete"
              )}
            </li>



          </ul>
        </div>
      )}
    </div>
  );
};

export default ActionsMenu;
